import { render, staticRenderFns } from "./editEvent.vue?vue&type=template&id=764b0c31&scoped=true&"
import script from "./editEvent.vue?vue&type=script&lang=js&"
export * from "./editEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b0c31",
  null
  
)

export default component.exports